<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot"><span class="epub-i">For I the Lord thy God am a jealous God, visiting the iniquity of the fathers upon the children unto the third and fourth generation of them that hate me.</span></p>
<p class="epc"><span class="epub-i">Exodus 20:5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?13adf14c